import styled from "styled-components"

import Modal, {Close, ModalInner} from "@irati/ui/src/Modal"

export const DefaultModal = styled(Modal)`
  ${ModalInner}{
    padding: 0;
  }

  ${Close}{
    top: 20px;
    right: 20px;
  }
`
